"use client"

import { sendBlockEvent } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import CommonTitle from "ui/common/bit/CommonTitle"
import BlockWrapper from "../common/BlockWrapper"
import ProductCarInsuranceBoxesContent from "./ProductCarInsuranceBoxesContent"

const StyledTitlesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ProductAdditionalOptionsComponent = ({ data, id }: any) => {
  const { title, subtitle, itemsList } = data

  if (!itemsList || !itemsList.blocks || itemsList.blocks.length === 0) {
    return null
  }
  const handleCardClick = (buttonTitle: string) => {
    sendBlockEvent({
      blockId: id || "1",
      title: title?.value,
      componentName: "הוספת כיסויים",
      productName: data?.productName || data?.formDefaultInsuranceType,
      buttonName: buttonTitle,
    })
  }

  return (
    <BlockWrapper id={id}>
      <StyledTitlesContainer>
        <CommonTitle title={title?.value} subtitle={subtitle?.value} />
      </StyledTitlesContainer>
      <ProductCarInsuranceBoxesContent
        itemsList={itemsList}
        onItemClick={handleCardClick}
      />
    </BlockWrapper>
  )
}

export default ProductAdditionalOptionsComponent
